<template>
  <button
    :data-testid="dataTestId"
    class="item-button d-flex layout-row align-items-center i-radius-xl i-px-8 i-py-8"
    @click="onBtnClick()"
    @mouseenter="hovering = true"
    @mouseleave="hovering = ''"
  >
    <div class="content d-flex layout-row align-items-center">
      <i-featured-icon
        :size="iFeaturedIconSizes.SM"
        :symbol="icon"
        :type="iconType"
      ></i-featured-icon>
      <div class="text d-flex flex-column align-items-start">
        <div class="i-text-button-3 i-text-neutral-120">{{ primaryText }}</div>
        <div class="i-text-body-3 i-text-neutral-110">{{ secondaryText }}</div>
      </div>
      <div class="icon-coin">
        <slot name="icon-coin">
          <i-icon-button
            symbol="medium-chevron-right"
            size="md"
            type="transparent"
            @button-click="onBtnClick()"
          ></i-icon-button>
        </slot>
      </div>
    </div>
  </button>
</template>

<script>
import {
  iFeaturedIcon,
  iFeaturedIconSizes,
  iIconButton,
} from '@inscribe/signal';

export default {
  components: { iFeaturedIcon, iIconButton },
  props: {
    dataTestId: {
      type: String,
      default: 'item-icon',
    },
    icon: {
      type: String,
      default: null,
    },
    iconType: {
      type: String,
      default: 'primary',
    },
    primaryText: {
      type: String,
      default: '',
    },
    secondaryText: {
      type: String,
      default: null,
    },
    onBtnClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return { iFeaturedIconSizes, hovering: false };
  },
};
</script>

<style lang="scss" scoped>
.item-button {
  width: 100%;
  height: 68px;
  border: 1px solid $light-neutral-60;
  background: $light-neutral-default;
  box-sizing: border-box;

  &:hover,
  &:active {
    border: 1px solid $light-neutral-80;
  }

  .content {
    gap: 12px;
    width: 100%;

    .text {
      flex: 1;
    }
  }
}
</style>
